import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { FieldLabel, FieldRoot, HelperText, LabelRow, RequiredMark } from "../FormField/FormField.styles";
import { duration, easing } from "../../../design-system/tokens/transitions";

const FORM_INPUT_FILL = "#FAFAFC";

export { FieldRoot, FieldLabel, HelperText, LabelRow, RequiredMark };

export const StyledTextArea = styled.textarea<{ $invalid?: boolean }>`
  width: 100%;
  min-height: 120px;
  padding: ${spacing[3]};
  margin: 0;
  box-sizing: border-box;
  resize: vertical;
  background-color: ${FORM_INPUT_FILL};
  border: 1px solid
    ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  color: ${rawColors.text.highEmphasis};
  ${typographyMixin("body", 3)}
  outline: none;
  transition: border-color ${duration.fast} ${easing.smooth};

  &::placeholder {
    color: ${rawColors.text.lowEmphasis};
    font-weight: 500;
  }

  &:hover:not(:disabled):not(:focus) {
    border-color: ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.stroke[300]};
  }

  &:focus {
    border-color: ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.primary[500]};
  }
`;
